export const socialKeys = {
  socialArticle: params => ["socialArticle", params],
  socialArticles: ["socialArticles"],
  socialArticleComments: params => ["socialArticlesComments", params],
  socialArticleReComments: params => ["socialArticleReComments", params],
};
